import { createAction, props } from '@ngrx/store';

import { Barn, Silo } from '../../models/barn.model';

export const clearBarnState = createAction('[Barn] Clear barn state');
export const loadBarnsRequest = createAction('[Barn] Load barns request');
export const loadBarnsSuccess = createAction(
  '[Barn] Load barns success',
  props<{ barns: Barn[] }>(),
);
export const loadBarnsFailed = createAction('[Barn] Load barns failed', props<{ error: Error }>());

export const upsertBarnRequest = createAction(
  '[Barn] Upsert barn request',
  props<{ barn: Barn }>(),
);
export const upsertBarnSuccess = createAction(
  '[Barn] Upsert barn success',
  props<{ barn: Barn }>(),
);
export const upsertBarnFailed = createAction(
  '[Barn] Upsert barn failed',
  props<{ error: Error }>(),
);

export const deleteBarnRequest = createAction(
  '[Barn] Delete barn request',
  props<{ barn: Barn }>(),
);
export const deleteBarnWithConfirmation = createAction(
  '[Barn] Confirm Delete barn',
  props<{ barn: Barn }>(),
);
export const deleteBarnSuccess = createAction(
  '[Barn] Delete barn success',
  props<{ barn: Barn }>(),
);
export const deleteBarnFailed = createAction(
  '[Barn] Delete barn failed',
  props<{ error: Error }>(),
);

export const upsertBarn = createAction('[Barn] Upsert barn', props<{ barn: Barn }>());
export const setSelectedBarn = createAction(
  '[Barn] Set Selected barn',
  props<{ barnId?: number }>(),
);

/** SILOS ACTIONS */
export const loadSilosRequest = createAction('[Silo] Load silos request');
export const loadSilosSuccess = createAction(
  '[Silo] Load silos success',
  props<{ silos: Silo[] }>(),
);
export const loadSilosFailed = createAction('[Silo] Load silos failed', props<{ error: Error }>());
